<div class="date-filter">
  <mat-form-field appearance="outline">
    <input matInput
      [matDatepicker]="fromDate"
      [max]="dateTo || today"
      [(ngModel)]="dateFrom"
      (ngModelChange)="onDateChange()"
    >
    <mat-label>From</mat-label>
    <mat-datepicker-toggle matIconSuffix [for]="fromDate"></mat-datepicker-toggle>
    <mat-datepicker #fromDate></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>To</mat-label>
    <input matInput
      [matDatepicker]="toDate"
      [min]="dateFrom"
      [max]="today"
      [(ngModel)]="dateTo"
      (ngModelChange)="onDateChange()"
    >
    <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
    <mat-datepicker #toDate></mat-datepicker>
  </mat-form-field>
</div>
